<template>
  <div>
    <div style="background-color: white; padding: 15px;">
      <div style="padding-bottom: 15px; border-bottom: 1px solid #e7e7e7">
        <span style="font-size: 13px; color:#97a8be">首页 / 系统设置 / 账号管理 / 添加管理员</span>
      </div>
      <div style="padding-top: 15px;">
        <table width="100%">
          <tr>
            <td class="leftTd">
              <span style="color: red">* </span>登录账号
            </td>
            <td style="text-align: left;padding-left: 15px; padding-top: 15px;">
              <input v-model="data.account" class="boxText"/>
            </td>
          </tr>
          <tr>
            <td class="leftTd">
              <span style="color: red">* </span>登录密码
            </td>
            <td style="text-align: left;padding-left: 15px; padding-top: 15px;">
              <input v-model="data.pwd" type="password" class="boxText"/>
            </td>
          </tr>
          <tr>
            <td class="leftTd">
              <span style="color: red">* </span>管理员昵称
            </td>
            <td style="text-align: left;padding-left: 15px; padding-top: 15px;">
              <input v-model="data.nickName" class="boxText"/>
            </td>
          </tr>
          <tr>
            <td class="leftTd">
              <span style="color: red">* </span>部门
            </td>
            <td style="text-align: left;padding-left: 15px; padding-top: 15px;">
              <input v-model="data.department" class="boxText"/>
            </td>
          </tr>
          <tr>
            <td class="leftTd">
              <span style="color: red"> </span>权限设置
            </td>
            <td style="text-align: left;padding-left: 15px; padding-top: 15px;">
              <div>
                <input type="checkbox" @click="setAut('添加管理员')">添加管理员
                <input type="checkbox" @click="setAut('编辑管理员')">编辑管理员
                <input type="checkbox" @click="setAut('删除管理员')">删除管理员
                <input type="checkbox" @click="setAut('查看管理员')">查看管理员<br/>
                <input type="checkbox" @click="setAut('添加项目')">添加项目
                <input type="checkbox" @click="setAut('编辑项目')">编辑项目
                <input type="checkbox" @click="setAut('删除项目')">删除项目
                <input type="checkbox" @click="setAut('查看项目')">查看项目<br/>
                <input type="checkbox" @click="setAut('查看统计信息')">查看统计信息
                <input type="checkbox" @click="setAut('查看财务数据')">查看财务数据
                <input type="checkbox" @click="setAut('查看投资')">查看投资
                <input type="checkbox" @click="setAut('查看工资')">查看工资
                <input type="checkbox" @click="setAut('查看余额宝')">查看余额宝<br/>
                <input type="checkbox" @click="setAut('查询签到记录')">查询签到记录<br/>
                <input type="checkbox" @click="setAut('查询用户银行卡')">查询用户银行卡<br/>
                <input type="checkbox" @click="setAut('查询实名申请')">查询实名申请
                <input type="checkbox" @click="setAut('审核实名申请')">审核实名申请
                <input type="checkbox" @click="setAut('删除实名申请')">删除实名申请<br/>
                <input type="checkbox" @click="setAut('添加等级')">添加等级
                <input type="checkbox" @click="setAut('编辑等级')">编辑等级
                <input type="checkbox" @click="setAut('删除等级')">删除等级
                <input type="checkbox" @click="setAut('查看等级')">查看等级<br/>
                <input type="checkbox" @click="setAut('添加文章')">添加文章
                <input type="checkbox" @click="setAut('编辑文章')">编辑文章
                <input type="checkbox" @click="setAut('删除文章')">删除文章
                <input type="checkbox" @click="setAut('查询文章')">查询文章<br/>
                <input type="checkbox" @click="setAut('添加充值银行卡')">添加充值银行卡
                <input type="checkbox" @click="setAut('编辑充值银行卡')">编辑充值银行卡
                <input type="checkbox" @click="setAut('删除充值银行卡')">删除充值银行卡
                <input type="checkbox" @click="setAut('查询充值银行卡')">查询充值银行卡<br/>
                <input type="checkbox" @click="setAut('添加系统配置')">添加系统配置
                <input type="checkbox" @click="setAut('编辑系统配置')">编辑系统配置
                <input type="checkbox" @click="setAut('删除系统配置')">删除系统配置
                <input type="checkbox" @click="setAut('查询系统配置')">查询系统配置<br/>
                <input type="checkbox" @click="setAut('添加团队等级')">添加团队等级
                <input type="checkbox" @click="setAut('编辑团队等级')">编辑团队等级
                <input type="checkbox" @click="setAut('删除团队等级')">删除团队等级
                <input type="checkbox" @click="setAut('查看团队等级')">查看团队等级<br/>
                <input type="checkbox" @click="setAut('查看充值')">查看充值
                <input type="checkbox" @click="setAut('审核充值')">审核充值
                <input type="checkbox" @click="setAut('查看转账')">查看转账
                <input type="checkbox" @click="setAut('审核转账')">审核转账
                <input type="checkbox" @click="setAut('查看提现')">查看提现
                <input type="checkbox" @click="setAut('审核提现')">审核提现<br/>
                <input type="checkbox" @click="setAut('注册用户')">注册用户
                <input type="checkbox" @click="setAut('查询用户')">查询用户
                <input type="checkbox" @click="setAut('修改用户')">修改用户
              </div>
            </td>
          </tr>
        </table>
      </div>

      <div style="padding-top: 15px; padding-left: 150px">
        <input @click="addAdmin" type="button" style="cursor: pointer; padding: 10px 25px; border-radius: 3px; background-color: #1890ff; border: 1px solid #1890ff; color: white" value="添加" />
        <input @click="goback" type="button" style="cursor: pointer; padding: 10px 25px; border-radius: 3px; background-color: #ffffff; border: 1px solid #dbdbdb; margin-left: 15px; color: #606266" value="返回" />
      </div>
    </div>

  </div>
</template>

<script>

import {closeLoading, DO_NET_URL, loading, toask} from "@/config/config";
import {axiosGet, axiosPostJson} from "@/main";

export default {
  name: "AddAdmin",
  data(){
    return{
      data:{
        account: "",
        pwd: "",
        nickName: "",
        department: "",
        authorityGroup: ""
      }
    }
  },
  mounted(){
    let that=this
    if(localStorage.getItem("iwa_token")==null||localStorage.getItem("iwa_token")==""){
      setTimeout(function (){
        that.$router.replace('index')
      },600);
    }
  },
  methods: {
    setAut(key){
      if(this.data.authorityGroup.indexOf("|"+key+",")!=-1){
        this.data.authorityGroup=this.data.authorityGroup.replace("|"+key+",","")
      }else{
        this.data.authorityGroup+="|"+key+","
      }
      console.log(this.data.authorityGroup)
    },
    addAdmin(){
      let that=this
      if(this.data.account==""){
        toask("请输入管理员账号！",6)
        return
      }
      if(this.data.pwd==""){
        toask("请输入管理员密码！",6)
        return
      }
      if(this.data.nickName==""){
        toask("请输入管理员昵称！",6)
        return
      }
      if(this.data.department==""){
        toask("请输入部门名称！",6)
        return
      }
      loading("请求中")
      axiosPostJson(DO_NET_URL+"Admin/AddAdmin",JSON.stringify(this.data),function (res){
        closeLoading()
        if(res.code==200){
          toask("添加成功",6)
          setTimeout(function (){
            that.$emit("send",'admin')
          },600)
        }else{
          toask(res.data,6)
        }
      })
    },
    goback(){
      this.$emit("send",'admin')
    },

  }
}
</script>

<style scoped>
.boxText{-webkit-appearance: none;
  background-color: #fff;
  background-image: none;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  color: #606266;
  display: inline-block;
  font-size: 12px;
  height: 40px;
  line-height: 40px;
  outline: none;
  padding: 0 15px;
  -webkit-transition: border-color .2s cubic-bezier(.645,.045,.355,1);
  transition: border-color .2s cubic-bezier(.645,.045,.355,1);
  width: 50%;}
.leftTd{text-align: right;
  vertical-align: middle;
  font-size: 12px;
  color: #606266;
  line-height: 40px;
  padding: 15px 12px 0 0;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;font-weight: 700; width: 120px}
.addBtn{color: #1890ff;background: #e8f4ff; border: 1px solid #1890ff; cursor: pointer; float: left; font-size: 12px;padding: 7px 15px;border-radius: 3px;}
.th{border-bottom:1px solid #dfe6ec; text-align: left; padding:0 10px;word-break: break-word;background-color: #f8f8f9;color: #515a6e;height: 40px;font-size: 12px;}
.td{border-bottom:1px solid #dfe6ec;padding:0 10px; word-break:break-word;background-color: #ffffff;color: #606266;height: 40px;font-size: 12px;}
</style>